
import { motion } from 'framer-motion';
import { MdSearch } from 'react-icons/md';
import { PropTypes } from 'prop-types';
import {  useState } from 'react';


const Filter = ({ handleIntake, search, setSearch }) => {
   
    const [open,] = useState(true)
    const handleChange = (e) => {
        setSearch(e.target.value)

    }
  
    const data = []

  

    return (
        <div className='w-full flex bg-gray-100 items-center justify-center p-3 pt-8'>
            <div className='w-full max-w-5xl'>
                <div className=" w-full  bg-white shadow-md 2xl:border rounded-md p-2">
                    <div className="grid  grid-cols-1 gap-3 md:gap-0 md:grid-cols-[25%_75%]   w-full ">
                      
                        <div
                            className="flex flex-col gap-1 items-start justify-center px-4 w-full"
                        >
                          
                            <input type="date"
                                className={`border-0 outline-none  w-full focus:outline-none  font-semibold text-[#878080]`}
                                name="closeDate"
                               
                                onChange={
                                    (e) => handleIntake(e.target.value)
                                }
                                id="close-date" />
                        </div>
                      
                        <div className="flex flex-1 items-center  w-full">
                            <input type="text" placeholder="Search" className="outline-none border-0 w-full flex-1 px-4" value={search} onChange={handleChange} />
                            <MdSearch className="2xl:w-8 2xl:h-8" />
                        </div>
                    </div>
                    {
                        data?.length > 0 &&
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={open ? { height: "fit-content", opacity: 1 } : { height: 0, opacity: 0 }}
                            transition={{ duration: .7, ease: 'easeInOut' }}
                            className={`w-full flex  flex-col z-40 `}>
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={open ? { opacity: 1 } : { opacity: 0 }}
                                transition={{ duration: .7, ease: 'easeInOut' }}
                                className={`${open ? "flex" : "hidden"} flex-col w-full h-full`}>
                                {
                                    data?.map((deg, index) => (
                                        <div key={index} className="grid grid-cols-[16vw_90%] items-center place-items-center gap-5 w-full  p-2 hover:bg-gray-100 cursor-pointer">
                                            {
                                                deg?.status &&
                                                <div className={`px-2.5 py-0.5 w-fit rounded-xl border ${deg?.status?.toLowerCase() === "closed" ? "border-red-600 text-red-600" : "border-blue-900 text-blue-900"} justify-center items-center gap-1.5 flex`}>
                                                    <div className="text-center  text-[8px] sm:text-xs font-medium leading-none uppercase whitespace-nowrap">{deg?.status}</div>
                                                </div>
                                            }
                                            <div className='flex flex-col gap-1 items-start justify-start w-full'>
                                                <h1 className="text-slate-900 text-2xl  font-bold  ">{deg?.name}</h1>
                                                {deg?.close && <span className="text-sky-950 text-opacity-70 text-base font-bold leading-normal">Close: {deg?.close}</span>}

                                            </div>
                                        </div>
                                    ))
                                }
                            </motion.div>
                        </motion.div>}
                </div>
            </div>
        </div>
    )
}
Filter.propTypes = {
    handleIntake: PropTypes.func,
    handleLevel: PropTypes.func,
    search: PropTypes.string,
    data: PropTypes.array,
    setSearch: PropTypes.func
}
export default Filter